import TeamGenerationWidget from './TeamGenerationWidget';
export default TeamGenerationWidget;
